import { RemoteLocation } from "./DataFetchingTypes";

export interface Document {
    id: number;
    /*
     * document name, usually the upload name
     */
    name: string;
    /**
     * document unique identifier, in this case the sha1
     */
    documentSerialId: string;
    uploadDate: Date;
    objectLocation: RemoteLocation;
    pageCount: number;
    images?: DocumentPageImage[];
}

export interface DocumentArchive {
    id: number;
    filename: string;
    uploadDate: Date;
    uploader: number;
    uploadId: number;
    status: ArchiveStatus;
    files?: DocumentDataInstance[];
}

export enum UploadType {
    PDF = "pdf",
    DOC = "doc",
    DOCX = "docx",
    XLS = "xls",
    XLSX = "xlsx",
    PPT = "ppt",
    PPTX = "pptx",
    TXT = "txt",
    RTF = "rtf",
    MD = "md",
    CSV = "csv",
    ODT = "odt",
    ODS = "ods",
    ODP = "odp",
    ZIP = "zip",
    UNKNOWN = "UNKNOWN",
}

export enum ArchiveStatus {
    processing = "Processing",
    complete = "Complete",
    failure = "Fail",
}

export interface DocumentPageImage {
    objectLocation: RemoteLocation;
    page: number;
}

export interface AnnotationValue {
    pageNumber: number;
    attributeName: string;
    attributeLabel: string;
    attributeValue: any;
}

export interface AnnotationSKU {
    annotationValues: AnnotationValue[];
}

export interface DocumentDataInstance {
    orderFormId: number;
    documentId: number;
    filename: string;
    creationDate: Date;
    processed: boolean;
    shouldProcess: boolean;
    /**
     file id, usually the file sha1
    **/
    documentSerialId: string;
    /**
     id of the associated archive if any
    **/
    archiveId?: number;
    uploadId?: number;
    attributes?: AnnotationValue[];
    skus?: AnnotationSKU[];
}

export interface DocumentUpload {
    id: number;
    uploadType: UploadType;
    uploadDate: Date;
}
/**
transient objects
**/
export interface GetUploadDocumentResponse {
    upload: DocumentUpload;
    files: DocumentArchive[] | DocumentDataInstance[];
}
